module.exports = __webpack_public_path__ + "static/media/cosaic_1.a960b69e.png";